export default function HowToDeleteAccount() {
  return (
    <div style={{ maxWidth: "600px", margin: "40px auto", padding: "0 20px" }}>
      <h1>How to Delete Your Zeeguu Account</h1>

      <p>
        You can delete your Zeeguu account at any time. Follow these steps:
      </p>

      <h2>Steps to Delete Your Account</h2>
      <ol>
        <li>Log in to your Zeeguu account at <a href="https://zeeguu.org">zeeguu.org</a> or in the mobile app</li>
        <li>Go to <strong>Settings</strong> (click your profile or the gear icon)</li>
        <li>Select <strong>Delete Account</strong></li>
        <li>Confirm the deletion when prompted</li>
      </ol>

      <h2>What Data Will Be Deleted</h2>
      <p>When you delete your account, the following data will be permanently removed:</p>
      <ul>
        <li>Your profile information (name, email)</li>
        <li>Your reading history and saved articles</li>
        <li>Your vocabulary and word translations</li>
        <li>Your exercise history and learning progress</li>
        <li>Your preferences and settings</li>
      </ul>

      <h2>Data Retention</h2>
      <p>
        Your account and all associated data will be permanently deleted within 30 days of your request.
        This action cannot be undone.
      </p>

      <h2>Need Help?</h2>
      <p>
        If you have trouble deleting your account or have questions, contact us at{" "}
        <a href="mailto:zeeguu.team@gmail.com">zeeguu.team@gmail.com</a>
      </p>
    </div>
  );
}
